"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainTheme = void 0;
const Colors_1 = require("../Colors");
exports.MainTheme = {
    ErrorContainer: {
        color: Colors_1.Colors.pink[0],
        background: `${Colors_1.Colors.red[6]}ee`,
        border: `1px solid ${Colors_1.Colors.red[0]}`,
    },
    Sidebar: { background: Colors_1.Colors.grey[8] },
};
